import PropTypes from 'prop-types';
import { useMemo } from 'preact/hooks';

export default function Picker({
  items = [{ name: 'Empty', value: 'null' }],
  currentValue,
  fieldName,
  onChange,
  labelText,
  hidden = false,
  loading = false,
  disabled = false,
  label = null,
  className = null,
  emptyLabel = 'Please pick a value',
}) {
  if (hidden) return <></>;

  let skeletonBlock;

  function filterOnChange(e) {
    if (`${e.target.value}`.length > 0) onChange(e);
  }

  if (loading)
    if (labelText || label)
      skeletonBlock = (
        <div className="skeleton absolute top-10 bottom-0 left-0 right-0"></div>
      );
    else
      skeletonBlock = (
        <div className="skeleton absolute top-0 bottom-0 left-0 right-0"></div>
      );

  const options = useMemo(() => {
    return items.map((item) => {
      if (currentValue === item.value && currentValue !== null)
        return (
          <option key={item.value} value={item.value} selected>
            {item.name}
          </option>
        );
      else if (item.value !== 'empty')
        return (
          <option key={item.value} value={item.value}>
            {item.name}
          </option>
        );
      else
        return (
          <option key="empty-item" value="">
            {emptyLabel}
          </option>
        );
    });
  }, [items, currentValue, emptyLabel]);

  if (!labelText && !label)
    return (
      <div className={className ? `relative ${className}` : 'relative'}>
        <select
          className="select select-bordered w-full"
          onChange={filterOnChange}
          name={fieldName}
          disabled={disabled || loading}
        >
          {options}
        </select>
        {skeletonBlock}
      </div>
    );
  else
    return (
      <label
        className={
          className
            ? `form-control w-full relative ${className}`
            : 'form-control w-full relative'
        }
      >
        <div className="label">
          <span
            className={`label-text ${disabled ? 'opacity-50' : 'opacity-100'}`}
          >
            {labelText ?? label}
          </span>
        </div>
        <select
          className="select select-bordered relative"
          onChange={filterOnChange}
          name={fieldName}
          disabled={disabled || loading}
        >
          {options}
        </select>
        {skeletonBlock}
      </label>
    );
}

Picker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentValue: PropTypes.any,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.node,
  className: PropTypes.string,
};
